import { render, staticRenderFns } from "./BlockVideoAudioUpload.vue?vue&type=template&id=41a9c494"
import script from "./BlockVideoAudioUpload.vue?vue&type=script&lang=js"
export * from "./BlockVideoAudioUpload.vue?vue&type=script&lang=js"
import style0 from "./BlockVideoAudioUpload.vue?vue&type=style&index=0&id=41a9c494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports